// ConfirmationModal.js
import React from "react";

const ConfirmationModal = ({ isOpen, onClose, onConfirm, message }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="bg-white p-5 rounded shadow-lg">
        <h3 className="text-lg mb-4">{message}</h3>
        <div className="flex justify-end">
          <button onClick={onClose} className="mr-2 bg-gray-400 text-white py-1 px-3 rounded">
            Cancel
          </button>
          <button onClick={onConfirm} className="bg-blue-600 text-white py-1 px-3 rounded">
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
